import _extends from "@babel/runtime/helpers/extends";
import { styled } from '@moonpig/launchpad-utils';
import { system as s } from '@moonpig/launchpad-system';
import { AspectRatio, Image, ScreenReaderOnly } from '@moonpig/launchpad-components';
import * as React from 'react';
var StyledLink = styled.a.withConfig({
  displayName: "StyledLink",
  componentId: "slkxwl-0"
})(["position:relative;display:block;text-align:center;background-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.palette.eclipse.l90;
});
var StyledTitle = styled.span.withConfig({
  displayName: "StyledTitle",
  componentId: "slkxwl-1"
})(["position:absolute;color:", ";", " bottom:1rem;left:0;right:0;width:100%;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.text;
}, s({
  typography: 'display2'
}));
var StyledRows = styled.div.withConfig({
  displayName: "StyledRows",
  componentId: "slkxwl-2"
})(["display:flex;flex-direction:column;justify-content:space-between;"]);

var BlockLink = function BlockLink(_ref3) {
  var height = _ref3.height,
      width = _ref3.width,
      link = _ref3.link,
      imageUrl = _ref3.imageUrl,
      imageAlt = _ref3.imageAlt,
      title = _ref3.title,
      hideTitle = _ref3.hideTitle;
  var Title = hideTitle ? ScreenReaderOnly : StyledTitle;
  return React.createElement(StyledLink, {
    href: link
  }, React.createElement(Image, {
    aspectRatio: width / height,
    src: imageUrl,
    alt: imageAlt
  }), title && React.createElement(Title, null, title));
};

export var BlockItem = function BlockItem(props) {
  if ('nodes' in props) {
    return React.createElement(AspectRatio, {
      ratio: 1
    }, React.createElement(StyledRows, null, props.nodes.map(function (item, i) {
      return React.createElement(BlockLink, _extends({
        key: i
      }, item));
    })));
  }

  return React.createElement(BlockLink, {
    height: props.height,
    width: props.width,
    link: props.link,
    imageUrl: props.imageUrl,
    imageAlt: props.imageAlt,
    title: props.title,
    hideTitle: props.hideTitle
  });
};